export default {
  title: 'Servizio prenotazioni azienda disattivato',
  description: 'Il servizio di prenotazione è attualmente inattivo per questa azienda. Puoi attivarlo in Servizi.',
  button: {
    settings: 'Vai alle impostazioni',
  },
};
